import {
  useMemo,
  useCallback,
} from 'react';

import useTwilioEventFunctions from 'components/twilio/hooks/useTwilioEventFunctions';

const useJoinGroupChatSwitch = () => {
  const { joinGroupChat: twilioJoinGroupChat } = useTwilioEventFunctions();

  const joinBoothChat = useCallback((boothId: string, boothName?: string, _isAutoJoinMsgRequired = false) => {
    twilioJoinGroupChat(boothId);
  }, [twilioJoinGroupChat]);

  return useMemo(() => ({
    joinBoothChat,
  }), [joinBoothChat]);
};

export default useJoinGroupChatSwitch;
